import { createContext, useContext, useState } from "react";
import axios from "axios";

const RegisterContext = createContext();

// const BASE_URL = "http://localhost:8000";
const BASE_URL = process.env.REACT_APP_API_BASE_URL;

export const RegisterProvider = ({ children }) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [userNotFound, setUserNotFound] = useState(false);

  /**
   * Register API Call
   */
  const registerUser = async (payload) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/auth/register`,
        payload,
      );

      setSuccess(true);
      return data;
    } catch (err) {
      const msg = err.response?.data?.message || "Registration failed";
      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };
  /**
   * Login API Call
   */
  const loginUser = async (payload) => {
    setLoading(true);
    setError(null);
    setUserNotFound(false);

    try {
      const { data } = await axios.post(
        `${BASE_URL}/api/auth/loginAuth`,
        payload,
      );
      console.log("Data from login", data);
      return data;
    } catch (err) {
      const response = err.response;
      const code = response?.data?.code;
      const msg = response?.data?.message || "Login failed";

      // 👇 important for showing register link
      if (code === "USER_NOT_FOUND") {
        setUserNotFound(true);
      }

      setError(msg);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  return (
    <RegisterContext.Provider
      value={{
        registerUser,
        loginUser,
        userNotFound,
        loading,
        error,
        success,
      }}
    >
      {children}
    </RegisterContext.Provider>
  );
};

/**
 * Custom Hook
 */
export const useRegister = () => {
  const context = useContext(RegisterContext);
  if (!context) {
    throw new Error("useRegister must be used inside RegisterProvider");
  }
  return context;
};
